import { z } from "zod";
import {
  EDocumentKey,
  EDocumentList,
  EI9DocumentPhotoSide,
} from "@zeal/common";

const documentPhotoSchema = z.object({
  doc_url: z.string(),
  description: z.string().optional(),
  side: z.nativeEnum(EI9DocumentPhotoSide).optional(),
  file_suffix: z.number(),
});

const documentDataSchema = z.object({
  us_passport_number: z.string().optional(),
  expiration_date: z.string().optional(),
  issuing_authority: z.string().optional(),
  document_number: z.string().optional(),
  document_bc_number: z.string().optional(),
  alien_number: z.string().optional(),
  foreign_passport_number: z.string().optional(),
  country_code: z.string().optional(),
  i766_number: z.string().optional(),
  i94_number: z.string().optional(),
  us_state_code: z.string().optional(),
  document_sub_type_code: z.string().optional(),
  alien_number_or_i94_number: z.string().optional(),
  alien_number_or_i94_number_or_foreign_passport_number: z.string().optional(),
  sevis_number: z.string().optional(),
  visa_number: z.string().optional(),
});

const documentSchema = z.object({
  document_key: z.nativeEnum(EDocumentKey),
  document_list: z.nativeEnum(EDocumentList),
  document_photos: z.array(documentPhotoSchema).optional(),
  document_data: documentDataSchema.optional(),
  veriff_id: z.string().optional(),
  persona_inquiry_id: z.string().optional(),
});

export const getEmployeeI9DocumentsRequestSchema = z.object({
  employeeID: z.string().min(1),
});

export const getEmployeeI9DocumentsResponseSchema = z.object({
  employee: z.object({
    _id: z.string(),
    companyID: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    email: z.string(),
  }),
  documents: z.array(documentSchema),
  i9OnboardingInfo: z
    .object({
      workerID: z.string(),
      companyID: z.string(),
      last_completed_step: z.string(),
      documents_submitted_at: z.string().optional(),
    })
    .optional(),
});

export type TGetEmployeeI9DocumentsRequest = z.infer<
  typeof getEmployeeI9DocumentsRequestSchema
>;
export type TGetEmployeeI9DocumentsResponse = z.infer<
  typeof getEmployeeI9DocumentsResponseSchema
>;
